export default __webpack_public_path__ + "static/jobbox-3-c-045e197c3dc3ca4021ca2a74e474f076.webp";